import { Text } from "./styles"

export const Paragraph = (props) => {
  return <Text variant={props.variant} className={props.className}>{props.children}</Text>
}